import script from "./dev-debug.vue?vue&type=script&lang=ts&setup=true"
export * from "./dev-debug.vue?vue&type=script&lang=ts&setup=true"

import "./dev-debug.vue?vue&type=style&index=0&id=82486cc8&lang=scss&scoped=true"
import "./dev-debug.vue?vue&type=style&index=1&id=82486cc8&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82486cc8"]])

export default __exports__